import { useToggle } from "../../../../../hooks/useToggle.js";
import { useCurrentUser } from "../../../../AuthWrapper2/hooks/useCurrentUser.js";
import { useLocation } from "../../../../Locations/hooks/useLocation.js";
import { UserNameWithAvatar } from "../../../../Users/shared/UserNameWithAvatar.js";
import { FormikSelectUser } from "../../../../Users/shared/FormikSelectUser.js";
import { useMemo } from "react";
import { Button, FormLayout, Icon } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import { FieldArray, useFormikContext } from "formik";
//#region src/modules/Events/shared/CreateEventForm/components/EventAssignmentField.tsx
var EventAssignmentField = () => {
	const [showAddUser, toggleShowAddUser] = useToggle(false);
	const form = useFormikContext();
	const currentUser = useCurrentUser();
	const isCurrentUserAssigned = useMemo(() => form.values?.assignedUserIds?.find((userId) => userId === currentUser.id), [form.values]);
	const { data } = useLocation({ locationId: form.values.locationId }, {
		cacheStrategy: "cache-only",
		fire: !!form.values.locationId
	});
	return /* @__PURE__ */ jsx(FormLayout.Section, {
		heading: "Assignment",
		children: /* @__PURE__ */ jsx(FieldArray, {
			name: "assignedUserIds",
			render: (arrayHelpers) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "space-y-sm",
				children: form.values.assignedUserIds?.map((userId, i) => {
					return /* @__PURE__ */ jsxs("div", {
						className: "space-x-xxs flex items-center",
						children: [/* @__PURE__ */ jsx(Button, {
							onClick: () => arrayHelpers.remove(i),
							subtle: true,
							size: "sm",
							variant: "critical",
							children: /* @__PURE__ */ jsx(Icon, {
								Icon: IoClose,
								size: "sm"
							})
						}), /* @__PURE__ */ jsx(UserNameWithAvatar, { userId })]
					}, i + userId);
				})
			}), /* @__PURE__ */ jsxs("div", {
				className: "space-x-xxs flex items-center",
				children: [!isCurrentUserAssigned && /* @__PURE__ */ jsxs(Button, {
					className: "my-base space-x-xxs",
					onClick: () => arrayHelpers.push(currentUser.id),
					variant: "main",
					children: [
						/* @__PURE__ */ jsx(Icon, {
							Icon: IoMdAdd,
							size: "sm"
						}),
						" ",
						/* @__PURE__ */ jsx("span", { children: "Assign Yourself" })
					]
				}), showAddUser ? /* @__PURE__ */ jsx("div", {
					className: "grow",
					children: /* @__PURE__ */ jsx(FormikSelectUser, {
						multi: true,
						name: "assignedUserIds",
						placeholder: "Select User to Assign",
						hideValue: true,
						showStatus: true,
						usersWithStatusFirst: true,
						showDistanceFromGeo: data?.location?.geo?.coordinates
					})
				}) : /* @__PURE__ */ jsxs(Button, {
					className: "my-base space-x-xxs",
					onClick: toggleShowAddUser,
					subtle: true,
					variant: "main",
					children: [
						/* @__PURE__ */ jsx(Icon, {
							Icon: IoMdAdd,
							size: "sm"
						}),
						" ",
						/* @__PURE__ */ jsx("span", { children: "Add User Assignment" })
					]
				})]
			})] })
		}, `${showAddUser}/${isCurrentUserAssigned}`)
	});
};
//#endregion
export { EventAssignmentField };

//# sourceMappingURL=EventAssignmentField.js.map